import { Route, Routes } from 'react-router';
import { Layout } from '@/features/login/Layout';
import { WithQueryParams } from '@livefree/react';
import { Login } from '@/features/login';
import { RegisterLayout, Register } from '@/features/login/registration';
import { ForgotLayout, Forgot, Reset, Verify } from '@/features/login/forgot';

export const Router = () => (
  <Routes>
    <Route path="/*" element={<Layout />}>
      <Route index element={<Login />} />
      <Route path="register/*" element={<WithQueryParams element={RegisterLayout} />}>
        <Route index element={<Register />} />
      </Route>
      <Route element={<ForgotLayout />}>
        <Route path="require-reset" element={<Forgot isRequired />} />
        <Route path="forgot-password" element={<Forgot />} />
        <Route path="reset-password" element={<Reset />} />
        <Route path="verify" element={<Verify />} />
      </Route>
    </Route>
  </Routes>
);
